/* eslint-disable @tanstack/query/exhaustive-deps */
import { UseQueryResult, useQuery } from 'react-query'

import { BrandDetailsProps } from 'features/brand/brand-details'

import httpClient from 'services/http-client'

import { TEN_MINUTES_STALE_TIME } from 'constants/apis'

export const GET_BRAND_PAGE = '/brands/brand-page/preview'
export const BRAND_QK = 'brand'

export const useGetBrandByKey = (key: string): UseQueryResult<BrandDetailsProps> =>
  useQuery({
    queryKey: [BRAND_QK, key],
    queryFn: async () => {
      const { data: brand } = await httpClient.get<BrandDetailsProps>(`${GET_BRAND_PAGE}/${key}`)
      return brand
    },
    staleTime: TEN_MINUTES_STALE_TIME,
  })
